__turbopack_context__.v({
  "loader": "cVSDDW_loader",
  "loader--is-inner": "cVSDDW_loader--is-inner",
  "loader--with-text": "cVSDDW_loader--with-text",
  "loader__logo-container": "cVSDDW_loader__logo-container",
  "loader__logo-container--centered": "cVSDDW_loader__logo-container--centered",
  "loader__text-container": "cVSDDW_loader__text-container",
});
